import React, { useState } from 'react';
import styles from './index.module.scss';

type PreviewVersion = string | undefined;

const VersionPreview = () => {
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const revertToDefault = (event: React.MouseEvent) => {
    setIsSaving(true);
    if (window?.localStorage) {
      window.localStorage.removeItem('HOST_PANEL_PREVIEW_VERSION');
    }
    setIsSaving(false);
    window.location.reload(true);
  };

  let version: PreviewVersion;

  if (window?.localStorage) {
    version = window.localStorage.getItem('HOST_PANEL_PREVIEW_VERSION');
  }

  if (version) {
    return (
      <div className={styles.container}>
        <p className={styles.notice}>
          You are viewing a preview version! <br /> Version {version}
        </p>
        {
          <button onClick={revertToDefault} disabled={isSaving} className="button-action-small">
            {isSaving ? <span className="spinner" /> : 'Back to default'}
          </button>
        }
      </div>
    );
  }

  return null;
};

export default VersionPreview;
